import { render } from "./OrderProductDetail.vue?vue&type=template&id=f5823c5c&scoped=true"
import script from "./OrderProductDetail.vue?vue&type=script&lang=js"
export * from "./OrderProductDetail.vue?vue&type=script&lang=js"

import "./OrderProductDetail.vue?vue&type=style&index=0&id=f5823c5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5823c5c"]])

export default __exports__